import React, { useState, useEffect, useCallback } from 'react';

import { openConfirmPopup } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { lunaStreamsClient } from 'api';
import { UUID_PATTERN } from 'validators';

import { GroupEditForm } from './GroupEditForm';
import * as store from './store';

function GroupPage({
  groupId,
  createGroup,
  updateGroup,
  deleteGroup,
  afterCreateGroup,
  afterDeleteGroup,
  fetchGroups,
}) {
  const { t } = useTranslation();
  const [groupData, setGroupData] = useState(undefined);

  useEffect(() => { fetchGroups(); }, [fetchGroups]);

  useEffect(() => {
    if (groupId === 'create') return;
    (async () => {
      const data = await lunaStreamsClient.groups.get(groupId);
      setGroupData(data);
    })();
  }, [groupId]);

  const onDelete = useCallback(() => {
    const message = <span>{t('lunaStreamsGroups:группа.подтверждение.удаление.текст')}</span>;

    const onConfirm = async () => {
      await deleteGroup(groupId);
      afterDeleteGroup();
    };

    openConfirmPopup({
      title: t('lunaStreamsGroups:группа.подтверждение.удаление.заголовок'),
      message,
      type: 'delete',
      onConfirm,
    });
  }, [groupId, deleteGroup, afterDeleteGroup, t]);

  const onSubmit = useCallback(async (params) => {
    if (groupId === 'create') {
      const createdGroupId = await createGroup(params);
      if (createdGroupId?.match(UUID_PATTERN)) afterCreateGroup(createdGroupId);
    } else updateGroup(groupId, params);
  }, [groupId, createGroup, updateGroup, afterCreateGroup]);

  return (
    <GroupEditForm
      onDelete={onDelete}
      onSubmit={onSubmit}
      state={groupId === 'create' ? 'create' : 'edit'}
      values={groupData}
    />
  );
}

GroupPage.propTypes = {
  groupId: PropTypes.string.isRequired,
  createGroup: PropTypes.func.isRequired,
  updateGroup: PropTypes.func.isRequired,
  deleteGroup: PropTypes.func.isRequired,
  afterCreateGroup: PropTypes.func.isRequired,
  afterDeleteGroup: PropTypes.func.isRequired,
  fetchGroups: PropTypes.func.isRequired,
};

export default connect(() => ({
}), (dispatch) => ({
  createGroup: (params) => dispatch(store.createGroup(params)),
  updateGroup: (groupId, params) => dispatch(store.updateGroup(groupId, params)),
  deleteGroup: (groupId) => dispatch(store.deleteGroup(groupId)),
  fetchGroups: () => dispatch(store.fetchGroups),
}))(GroupPage);
